import { Entity, getEntitySourceLocation } from '@backstage/catalog-model';

export const DBML_LOCATION_ANNOTATION = 'backstage.io/dbml-location';

export function getDbmlLocationPath(entity: Entity): string | undefined {
  return entity.metadata.annotations?.[DBML_LOCATION_ANNOTATION]?.trim();
}

export function isDbmlAvailable(entity: Entity): boolean {
  return Boolean(getDbmlLocationPath(entity));
}

type ScmUrlResolver = {
  resolveUrl(opts: { url: string; base: string }): string;
};

/** Resolve annotation path (e.g. docs/schema.dbml) to an SCM URL. */
export function getDbmlLocationUrl(
  entity: Entity,
  scmIntegrations: ScmUrlResolver,
): string {
  const path = getDbmlLocationPath(entity);
  if (!path) {
    throw new Error(`Missing DBML annotation: ${DBML_LOCATION_ANNOTATION}`);
  }
  return scmIntegrations.resolveUrl({
    url: path,
    base: getEntitySourceLocation(entity).target,
  });
}
